// Centralized destinations for the site's persistent "Register" CTA — the
// button that appears in the header on every page (desktop + mobile) and in
// the Home hero. Change it here, once, instead of hunting through every
// component that renders a Register button.
//
// Today this points at the internal /register catalog page (the program
// cards, driven by Supabase — see src/services/content.ts). If/when a
// dedicated signup app exists (e.g. app.triumphbasketball.com/auth/signup),
// swap the value below and every "Register" CTA that imports CONNECT_URL
// updates at once.
//
// Note: this is separate from the per-program `ctaLink` field on each
// register_products row in Supabase — those already point to the specific
// registration/checkout flow for that program and are meant to stay
// data-driven, not hardcoded here.
export const CONNECT_URL = "https://app.triumphbasketball.com/auth/signup";

// True if CONNECT_URL points outside this app (so callers know whether to
// render a router <Link> or a plain <a target="_blank">).
export const CONNECT_URL_IS_EXTERNAL = /^https?:\/\//.test(CONNECT_URL);
